import API from "./baseApi";

const getCategories = (payload) => {
  if (payload && Object.keys(payload).length) {
 let query = "?";
    Object.keys(payload).map((x) => {
      if (payload[x] !== undefined && payload[x] !== null) {
        let value = payload[x];
        if (typeof value === "object") {
          value = JSON.stringify(value);
        }
        query = query + `${x}=${value}&`;
      }
    });
    return API.get("/services/categories/get" + query, payload);
  } else {
    return API.get("/services/categories/get", payload);
  }
};

const getSubCategory = (payload) => {
  if (payload && Object.keys(payload).length) {
 let query = "?";
    Object.keys(payload).map((x) => {
      if (payload[x] !== undefined && payload[x] !== null) {
        let value = payload[x];
        if (typeof value === "object") {
          value = JSON.stringify(value);
        }
        query = query + `${x}=${value}&`;
      }
    });
    return API.get("/services/subCategories/get" + query, payload);
  } else {
    return API.get("/services/categories/get", payload);
  }
};


const createCategory = (payload) => {
  return API.post("/services/categories/create", payload);
};

const updateCategory = (id, payload) => {
  return API.put(`/services/categories/update/${id}`, payload);
};

const createCategoryMapping = (payload) => {
  return API.post(`/services/categories/createCategoryMapping`, payload);
};

const deleteCatergoryMapping = (payload) => {
  return API.post(`/services/categories/deleteCatergoryMapping`, payload);
};

const createSubCategoryMapping = (payload) => {
  return API.post(`/services/subcategories/createSubCategoryMapping`, payload);
};
const updateCategoryType = (payload) => {
  return API.post(`/services/categories/updateType`, payload);
};

// // Sub categories
// const getSubCategory = (payload) => {
//   return API.get("/services/subCategories/get", payload);
// };

const createSubCategory = (payload) => {
  return API.post("/services/subcategories/create", payload);
};
export default {
  getCategories,
  createCategory,
  updateCategory,
  createCategoryMapping,
  deleteCatergoryMapping,
  getSubCategory,
  createSubCategoryMapping,
  updateCategoryType,
  getSubCategory,
  createSubCategory,
};
